import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { GlobalConstants } from '../common/global-constants';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { makeStateKey, TransferState } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class WebServiceService {
  public getMenuSubject$ = new BehaviorSubject<string>('_');
  menuChanged$ = this.getMenuSubject$.asObservable();

  public triggerComponent$ = new BehaviorSubject<any>([]);
  triggerComp$ = this.triggerComponent$.asObservable();

  public inpageNav$ = new BehaviorSubject<any>([]);
  getCompId$ = this.inpageNav$.asObservable();

  public pageHasNav$ = new BehaviorSubject<boolean>(false);
  getNavInfo$ = this.pageHasNav$.asObservable();

  public cookieController$ = new BehaviorSubject<boolean>(true);
  getCookieStatus$ = this.cookieController$.asObservable();

  public layoutNav$ = new BehaviorSubject<boolean>(false);
  getLayoutInfo$ = this.layoutNav$.asObservable();

  private triggerLottie = new Subject<any>();

  private isModalCalculatorActive = new Subject<any>();

  private isModalActive = new Subject<any>();

  private isDModalActive = new Subject<any>();

  private isModalSmsActive = new Subject<any>();
  private isPasoModalSmsActive = new Subject<any>();

  public scrollMockup$ = new BehaviorSubject<any>({});
  detectScrollMockup$ = this.scrollMockup$.asObservable();
  public isBrowser: boolean;
  constructor(private http: HttpClient, private router: Router,
    private readonly transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  sendModalCalStatus(status: boolean, menu: any, item: any) {
    this.isModalCalculatorActive.next({
      status: status,
      menu: menu,
      items: item,
    });
  }

  sendModalStatus(status: boolean, menu: any) {
    this.isModalActive.next({ status: status, menu: menu });
  }
  getModalStatus(): Observable<any> {
    return this.isModalActive.asObservable();
  }

  sendModalSmsStatus(status: boolean) {
    this.isModalSmsActive.next({ status: status });
  }
  getModalSmsStatus(): Observable<any> {
    return this.isModalSmsActive.asObservable();
  }

  sendPassoModalSmsStatus(status: boolean) {
    this.isPasoModalSmsActive.next({ status: status });
  }
  getPassoModalSmsStatus(): Observable<any> {
    return this.isPasoModalSmsActive.asObservable();
  }

  updatePage(menu_url: string) {
    this.getMenuSubject$.next(menu_url);
  }

  triggerComp(menu: any) {
    this.triggerComponent$.next(menu);
  }

  public HttpGet(url: string, showloader = false) {
    var apiUrl = GlobalConstants.apiURL;
    const key = makeStateKey(url.replace(apiUrl, ""));
    //ssr ile local çekim yapılırken 80 portunu kullanıyoruz.
    if(!this.isBrowser)
    {
      apiUrl = apiUrl.replace('https','http');
    }

    if(this.transferState.hasKey(key))
    {
      return new Observable((observer) => {
        const data = this.transferState.get<any>(key, null);
        
        observer.next(data);
        observer.complete();
      });
    }

    if (showloader) {
    }
    const request = this.http.get(apiUrl + url);

    return new Observable((observer) => {
      request.subscribe(
        (res) => {
          this.transferState.set(key, res as any);
          observer.next(res);
          observer.complete();
        },
        (error) => {
        },
        () => {
        }
      );
    });
  }

  public HttpApiPost(url: string, obj: any, showloader = false) {
    var apiUrl = GlobalConstants.apiURL;
    //ssr ile local çekim yapılırken 80 portunu kullanıyoruz.
    if(!this.isBrowser)
    {
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
    }

    if (showloader) {
    }
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' }); //, 'Authorization': 'Bearer ' + token
    const request = this.http.post(apiUrl + url, obj, {
      headers: reqHeader,
    });

    return new Observable((observer) => {
      request.subscribe(
        (res) => {
          observer.next(res);
          observer.complete();
        },
        (error) => {
        },
        () => {
        }
      );
    });
  }

  public HttpPostAuth(url: string, obj: any, showloader = false) {
    let token: any;

    if(!this.isBrowser)
    {
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
    }

    token = sessionStorage.getItem('token');

    if (!token) {
      let authData = {
        grant_type: 'client_credentials',
        client_id: 'XFGbd1LK8mnD.com.aktifbank.NKolayCom',
        client_secret: '4ltH56YhCyr5E78UpRYs4Kt6H',
      };

      return new Observable((observer) => {
        this.HttpPost('/identity/authenticate', authData).subscribe(
          (res: any) => {
            localStorage.setItem('access_token', res.access_token);
            token = res.access_token;
            const reqHeader = new HttpHeaders({
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token,
            });
            const request = this.http.post(
              GlobalConstants.apiCalculate + url,
              obj,
              { headers: reqHeader }
            );

            request.subscribe(
              (res) => {
                observer.next(res);
                observer.complete();
              },
              (error) => {
                if (error.status == 401) {
                  sessionStorage.removeItem('token');
                  window.location.assign('/');
                }
              }
            );
          }
        );
      });
    }
    const helper = new JwtHelperService();
    const isExpired = helper.isTokenExpired(token);
    if (isExpired) {
      let authData = {
        grant_type: 'client_credentials',
        client_id: 'XFGbd1LK8mnD.com.aktifbank.NKolayCom',
        client_secret: '4ltH56YhCyr5E78UpRYs4Kt6H',
      };

      return new Observable((observer) => {
        this.HttpPost('/identity/authenticate', authData).subscribe(
          (res: any) => {
            localStorage.setItem('access_token', res.access_token);
            token = res.access_token;
            const reqHeader = new HttpHeaders({
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token,
            });
            const request = this.http.post(
              GlobalConstants.apiCalculate + url,
              obj,
              { headers: reqHeader }
            );

            request.subscribe(
              (res) => {
                observer.next(res);
                observer.complete();
              },
              (error) => {
                if (error.status == 401) {
                  sessionStorage.removeItem('token');
                  window.location.assign('/');
                }
              }
            );
          }
        );
      });
    }
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    }); //
    const request = this.http.post(GlobalConstants.apiCalculate + url, obj, {
      headers: reqHeader,
    });

    return new Observable((observer) => {
      request.subscribe(
        (res) => {
          observer.next(res);
          observer.complete();
        },
        (error) => {
          if (error.status == 401) {
            sessionStorage.removeItem('token');
            window.location.assign('/');
          }
        }
      );
    });
  }

  
  public HttpPostAuthNonProxy(url: string, obj: any, showloader = false, headerLangValue = false) {
    let token: any;

    if (!this.isBrowser) {
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
    }

    token = sessionStorage.getItem('token');

    if (!token) {
      let authData = {
        grant_type: 'client_credentials',
        client_id: 'XFGbd1LK8mnD.com.aktifbank.NKolayCom',
        client_secret: '4ltH56YhCyr5E78UpRYs4Kt6H',
      };

      return new Observable((observer) => {
        this.HttpPost('/identity/authenticate', authData).subscribe(
          (res: any) => {
            localStorage.setItem('access_token', res.access_token);
            token = res.access_token;
            var reqHeader = new HttpHeaders({
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token,
            });

            if (headerLangValue) {
              reqHeader = new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
                'DC-Accept-Language': 'en-US'
              });
            }

            const request = this.http.post(
              GlobalConstants.apiURL + url,
              obj,
              { headers: reqHeader }
            );

            request.subscribe(
              (res) => {
                observer.next(res);
                observer.complete();
              },
              (error) => {
                if (error.status == 401) {
                  sessionStorage.removeItem('token');
                  window.location.assign('/');
                }
              }
            );
          }
        );
      });
    }
    const helper = new JwtHelperService();
    const isExpired = helper.isTokenExpired(token);
    if (isExpired) {
      let authData = {
        grant_type: 'client_credentials',
        client_id: 'XFGbd1LK8mnD.com.aktifbank.NKolayCom',
        client_secret: '4ltH56YhCyr5E78UpRYs4Kt6H',
      };

      return new Observable((observer) => {
        this.HttpPost('/identity/authenticate', authData).subscribe(
          (res: any) => {
            localStorage.setItem('access_token', res.access_token);
            token = res.access_token;
            const reqHeader = new HttpHeaders({
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token,
            });
            const request = this.http.post(
              GlobalConstants.apiURL + url,
              obj,
              { headers: reqHeader }
            );

            request.subscribe(
              (res) => {
                observer.next(res);
                observer.complete();
              },
              (error) => {
                if (error.status == 401) {
                  sessionStorage.removeItem('token');
                  window.location.assign('/');
                }
              }
            );
          }
        );
      });
    }
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    }); //
    const request = this.http.post(GlobalConstants.apiURL + url, obj, {
      headers: reqHeader,
    });

    return new Observable((observer) => {
      request.subscribe(
        (res) => {
          observer.next(res);
          observer.complete();
        },
        (error) => {
          if (error.status == 401) {
            sessionStorage.removeItem('token');
            window.location.assign('/');
          }
        }
      );
    });
  }

  public HttpPost(url: string, obj: any, showloader = false) {
    var apiUrl = GlobalConstants.apiCalculate;
    //ssr ile local çekim yapılırken 80 portunu kullanıyoruz.
    if(!this.isBrowser)
    {
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
    }

    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' }); // 'Authorization': 'Bearer ' + token

    const request = this.http.post(apiUrl + url, obj, {
      headers: reqHeader,
    });

    return new Observable((observer) => {
      request.subscribe(
        (res) => {
          observer.next(res);
          observer.complete();
        },
        (error) => {
        }
      );
    });
  }

  findPos(obj: HTMLElement) {
    if(obj)
    {
      var curtop = 0;
      if (obj.offsetParent) {
        do {
          curtop += obj.offsetTop;
        } while (obj = obj.offsetParent as HTMLElement);
        return curtop - 50;
      }
      return curtop;
    }
    return 0;
  }

  goDetail(url: string, menuclass: string = '') {
    if (!this.isBrowser) {
      return;
    }
    if (url == null || url == '') return;

    if (url && url.search('side-modal') > -1) {
      const _url = url.replace('#side-modal', '');
      this.HttpGet('/page?url=/' + GlobalConstants.lang + _url)
        .subscribe((res: any) => {
          this.sendModalStatus(true, res);
        });
      return;
    } else if (menuclass && menuclass.search('popup') > -1) {
      window.open(url, 'mywindow', 'toolbar=no,location=no,directories=no,status=no,titlebar=no,resizable=yes,scrollbars=yes,menubar=no,width=1024,height=636');
      return;
    } else if (url && url.search('modal') > -1) {
      let popup = GlobalConstants.layout.popup;
      popup.autoopen = true;
      this.triggerComp(popup);
      return;
    }

    if (url.includes('tel:')) {
      window.location.assign(url);
      return;
    }

    if (url.includes('http')) {
      if (url.includes('.nkolay.com/') || url.includes('nkolaykredi.com.tr')) {
        window.location.assign(url);
      } else {
        window.open(url, '_blank');
      }
    }
    else if (url.includes('#')) {
      if (url == '#mobil-uygulama-indir' && navigator) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          window.open('https://nkolay.page.link/PfBF', '_blank');
        } else {
          this.sendModalSmsStatus(true);
        }

        return;
      } else if (url == '#passomobil-indir' && navigator) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          window.open('https://passo.page.link/WoQJ', '_blank');
        } else {
          this.sendPassoModalSmsStatus(true);
        }

        return;
      }
      const templink = url.slice(url.indexOf('#') + 1);
      let currenturl = window.location.toString();
      let urlarr = currenturl.split('#');
      history.pushState(null, '', urlarr[0] + '#' + templink);

      const element: HTMLElement | null = document.getElementById(templink);
      const stickymenu: HTMLElement | null = document.getElementById('stickymenu');
      let offset = 0;
      if (stickymenu) {
        if (stickymenu.classList.value.search("sticky") > -1) {
          offset = stickymenu.offsetHeight;
        } else {
          offset = stickymenu.offsetHeight * 2;
        }
      }
      window.scroll({ top: this.findPos(element as HTMLElement) - offset, behavior: 'smooth' });
      history.pushState(null, '', urlarr[0]);
    } else {
      this.router.navigate([url]).then((data) => {
        localStorage.removeItem('bn-i');
        sessionStorage.removeItem('bannerList');
        this.updatePage(url);
      });
    }
  }
  dataLayerEvent(Category: string,Action: string,Label: string,noninteraction: boolean,event: string){
    if (!this.isBrowser) {
      return;
    }
    var dataLayer = (<any>window).dataLayer || [];
    dataLayer.push({
      'Category': Category,
      'Action': Action,
      'Label': Label,
      'noninteraction': noninteraction,
      'event': event
    });
  }
  dataLayerEventDimensions(Category: string,Action: string,Label: string,dimension5:string,noninteraction: boolean,event: string){
    if (!this.isBrowser) {
      return;
    }
    var dataLayer = (<any>window).dataLayer || [];
    dataLayer.push({
      'Category': Category,
      'Action': Action,
      'Label': Label, 
      'dimension5': dimension5,
      'noninteraction': noninteraction,
      'event': event
    });
  }
  //Haberler Impression
  dataLayerImpression4(Category: string,Action: string,Label: string,noninteraction: boolean,dimension4:Number,event: string){
    if (!this.isBrowser) {
      return;
    }
    var dataLayer = (<any>window).dataLayer || [];
    dataLayer.push({
      'Category': Category,
      'Action': Action,
      'Label': Label, 
      'noninteraction': noninteraction,
      'dimension4': dimension4,
      'event': event
    });
  }
  //Kredi hesaplama
  dataLayerCalculateCredit(Category: string,Action: string, Label: string, noninteraction:boolean, dimension6: Number, dimension7: Number, dimension8:Number, dimension9: string, event: string){
    if (!this.isBrowser) {
      return;
    }
    var dataLayer = (<any>window).dataLayer || [];
    dataLayer.push({
      'Category': Category,
      'Action': Action,
      'Label': Label,
      'noninteraction': noninteraction,
      'dimension6': dimension6, 
      'dimension7': dimension7,
      'dimension8': dimension8,
      'dimension9': dimension9,
      'event': event
    });
  }
  //Yatırım hesaplama
  dataLayerCalculateEarning(Category: string,Action: string, Label: string, noninteraction:boolean, dimension6: Number, dimension7: Number, dimension8:Number, dimension9: string, dimension10: string, event: string){
    if (!this.isBrowser) {
      return;
    }
    var dataLayer = (<any>window).dataLayer || [];
    dataLayer.push({
      'Category': Category,
      'Action': Action,
      'Label': Label,
      'noninteraction': noninteraction,
      'dimension6': dimension6, 
      'dimension7': dimension7,
      'dimension8': dimension8,
      'dimension9': dimension9,
      'dimension10': dimension10,
      'event': event
    });
  }
  //Impression Mid slider
  dataLayerImpressionMid(Category: string,Action: string, Label: string, dimension4:Number, dimension5: String, noninteraction: boolean, event: string){
    if (!this.isBrowser) {
      return;
    }
    var dataLayer = (<any>window).dataLayer || [];
    dataLayer.push({
      'Category': Category,
      'Action': Action,
      'Label': Label,
      'dimension4': dimension4, 
      'dimension5': dimension5,
      'noninteraction': noninteraction,
      'event': event
    });
  }

  dataLayerBannerClick(buttonName: string, mainCategory: string) {
    if (!this.isBrowser) {
      return;
    }
    
    const win = window as any;
    const dataLayer = win.dataLayer = win.dataLayer || [];
    
    const eventData: any = {
      'event': 'banner_click',
      'button_name': buttonName,
      'main_category': mainCategory
    };
    
    dataLayer.push(eventData);
  }

  dataLayerFooterMenuClick(buttonName: string, mainCategory?: string) {
    if (!this.isBrowser) {
      return;
    }
    
    const win = window as any;
    const dataLayer = win.dataLayer = win.dataLayer || [];
    
    const eventData: any = {
      'event': 'footer_menu_click',
      'button_name': buttonName
    };
    
    if (mainCategory) {
      eventData.main_category = mainCategory;
    }
    
    dataLayer.push(eventData);
  }

  dataLayerHeaderMenuClick(buttonName: string, mainCategory?: string, subCategory?: string) {
    if (!this.isBrowser) {
      return;
    }
    
    const win = window as any;
    const dataLayer = win.dataLayer = win.dataLayer || [];
    
    const eventData: any = {
      'event': 'header_menu_click',
      'button_name': buttonName
    };
    

    if (mainCategory) {
      eventData.main_category = mainCategory;
    }
    
    if (subCategory) {
      eventData.sub_category = subCategory;
    }
    
    dataLayer.push(eventData);
  }
  dataLayerInternetSubeClick(type: string) {
    if (!this.isBrowser) {
      return;
    }
    
    const win = window as any;
    const dataLayer = win.dataLayer = win.dataLayer || [];
  
    dataLayer.push({
      'event': 'int_sube_giris',
      'type': type
    });
  }
  
  dataLayerSearchBar(keyword: string) {
    if (!this.isBrowser) {
      return;
    }
    
    const win = window as any;
    const dataLayer = win.dataLayer = win.dataLayer || [];
    
    dataLayer.push({
      'event': 'search_bar',
      'keyword': keyword
    });
  }
  
  dataLayerSearchClick(keyword: string, buttonName: string, mainCategory: string) {
    if (!this.isBrowser) {
      return;
    }
    
    const win = window as any;
    const dataLayer = win.dataLayer = win.dataLayer || [];
    
    dataLayer.push({
      'event': 'search_bar',
      'keyword': keyword,
      'button_name': buttonName,
      'main_category': mainCategory
    });
  }
  
  dataLayerCalculationCard(miktar: string, vade: string, aylikTutar: string, faiz: string, urunTuru: string) {
    if (!this.isBrowser) {

      return;
    }
    
    const win = window as any;
    const dataLayer = win.dataLayer = win.dataLayer || [];
    
    dataLayer.push({
      'event': 'calculation_card',
      'miktar': miktar,
      'vade': vade,
      'aylık_tutar': aylikTutar,
      'faiz': faiz,
      'ürün_türü': urunTuru
    });
  }

  dataLayerKrediBasvuru(miktar: string = '', vade: string = '', aylikTutar: string = '', faiz: string = '', urunTuru: string = '', reffLink: string = '') {
    if (!this.isBrowser) {
      return;
    }
    
    const win = window as any;
    const dataLayer = win.dataLayer = win.dataLayer || [];
    
    const eventData: any = {
      'event': 'kredi_basvuru',
      'miktar': miktar,
      'vade': vade,
      'aylık_tutar': aylikTutar,
      'faiz': faiz,
      'ürün_türü': urunTuru
    };
    
    if (reffLink) {
      eventData.reff_link = reffLink;
    }
    
    dataLayer.push(eventData);
  }
}
